import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();

  const hideOn = [
    "/login",
    "/register",
    "/forgot-password",
  ];

  const shouldHide =
    hideOn.includes(location.pathname) ||
    location.pathname.startsWith("/reset-password");

  if (shouldHide) return null;

  return (
    <footer className="mt-12 border-t border-white/10 bg-[#121829] text-slate-300">
      <div className="mx-auto max-w-6xl px-6 py-8">

        {/* Branding */}
        <div className="flex flex-col items-center justify-center text-center">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500 to-cyan-500 text-lg font-bold text-white shadow-lg">
            AR
          </div>

          <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-400 italic">
            We value your time and financial growth.
          </p>
        </div>

        {/* Navigation */}
        <div className="mt-8 flex flex-wrap justify-center gap-6 border-t border-white/10 pt-5 text-sm font-medium">
          <Link
            to="/"
            className="transition duration-200 hover:text-white"
          >
            Home
          </Link>

          <Link
            to="/knowledge"
            className="transition duration-200 hover:text-white"
          >
            Knowledge
          </Link>
        </div>

        {/* Bottom */}
        <div className="mt-6 text-center text-xs text-slate-500">
          © {new Date().getFullYear()}
          <span className="mx-2">•</span>
          All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}